/**
 * Renders the commission module only when the gate is open; otherwise renders
 * NOTHING (not a "you lack access" card), so the module is absent rather than
 * advertised. See commissions-gate.ts for the rules and the seam.
 */
import type { ReactNode } from 'react';
import { useCommissionsGate } from './commissions-gate';

export function CommissionsGate({ children }: { children: ReactNode }) {
  const gate = useCommissionsGate();
  if (!gate.open) return null;
  return <>{children}</>;
}
